export default __webpack_public_path__ + "static/media/icon-arrow-left.4c179064.svg";